export type AllLicenseDetailsResponse = {
    licenseDetails: LicenseDetail[];
};

export type LicensesResponse = {
    active: ActiveLicense[];
    expired: ExpiredLicense[];
    upcoming: ExpiredLicense[];
};

export type ActiveLicense = {
    id: string;
    licenseId: string;
    licenseType: LicenseType;
    startDate: string;
    lastTokenUpdate: string;
    expirationDate: string | null;
    detail: LicenseDetail;
};

export type ExpiredLicense = {
    id: string;
    licenseId: string;
    licenseType: LicenseType;
    startDate: string;
    lastTokenUpdate: string;
    expirationDate: string | null;
};

export type LicenseDetail = {
    id: string;
    name: string;
    validity: LicenseValidity;
    isEnterprise: boolean;
    customViewLimit: number;
    featureFlags: LicenseFeatureFlag[];
    initialAnalysis: {
        byMail: number;
        byDay: number;
    };
    monthlyLimit: {
        byToken: number;
        byAnalysedMails: number;
    };
    historyLimit: {
        byMail: number;
        byMonth: number;
    };
};

export enum LicenseValidity {
    MONTHLY = "MONTHLY",
    YEARLY = "YEARLY",
    LIFETIME = "LIFETIME",
}

export enum LicenseFeatureFlag {
    MAIL_ENABLE_DEEPFOCUS = "MAIL_ENABLE_DEEPFOCUS",
    DASHBOARD_DISPLAY_CO2 = "DASHBOARD_DISPLAY_CO2",
    ASSISTANT_ENABLE_VOCAL = "ASSISTANT_ENABLE_VOCAL",
}

export enum LicenseType {
    B2B = "B2B",
    B2C = "B2C",
}
